const localizers = {
  'loading.msg': () => `กำลังโหลด…`,
  'SASServer.genericError.msg': () => `ไม่สามารถเข้าถึงเซิร์ฟเวอร์ได้`,
  'SASReport.genericError.msg': () => `ไม่สามารถโหลดรายงานที่เลือกได้`,
  'SASReportImage.genericError.msg': () => `ไม่สามารถโหลดภาพรายงานได้`,
  'SASReportImage.imageNotSupported.msg': () => `ไม่รองรับภาพสำหรับประเภทเนื้อหารายงานนี้`,
}
export default localizers;
